import styled from 'styled-components';

import colors from 'styles/colors';

export const Container = styled.div`
  flex: 1;
  min-height: 0;
  height: 100%;
  overflow-y: auto;
  background: ${colors.$white};
  padding: 40px 48px 64px;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${colors.$gray400};
    border-radius: 4px;
  }

  .library-inner {
    max-width: 1200px;
  }

  .eyebrow {
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 1.5px;
    color: ${colors.$gray500};
    margin-bottom: 12px;
  }

  .library-title {
    font-size: 38px;
    color: ${colors.$gray900};
    margin: 0 0 16px;
  }

  .library-desc {
    font-size: 16px;
    line-height: 1.6;
    color: ${colors.$gray600};
    max-width: 760px;
  }

  .library-search {
    gap: 10px;
    border: 1px solid ${colors.$gray300};
    padding: 11px 22px;
    margin-bottom: 20px;
    background: ${colors.$white};

    &:focus-within {
      border-color: ${colors.$dark_green};
    }

    i {
      font-size: 22px;
      color: ${colors.$gray500};
    }

    input {
      flex: 1;
      border: none;
      outline: none;
      background: transparent;
      font-size: 16px;
      color: ${colors.$dark_charcoal};

      &::placeholder {
        color: ${colors.$gray500};
      }
    }
  }

  .library-categories {
    gap: 10px;
    margin-bottom: 44px;

    .category-chip {
      border: 1px solid ${colors.$gray300};
      background: ${colors.$white};
      color: ${colors.$gray700};
      padding: 8px 16px;
      font-size: 14px;
      cursor: pointer;
      transition: all 0.15s;

      &:hover {
        border-color: ${colors.$gray400};
        background: ${colors.$gray100};
      }

      &.active {
        background: ${colors.$gray900};
        border-color: ${colors.$gray900};
        color: ${colors.$white};
      }
    }
  }

  .results-section + .results-section {
    margin-top: 44px;
  }

  .experts-header {
    margin-bottom: 20px;

    h2 {
      font-size: 22px;
      color: ${colors.$gray900};
      margin: 0;
    }

    .experts-count {
      font-size: 14px;
      color: ${colors.$gray500};
    }
  }

  .experts-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 20px;
  }

  .expert-card {
    border: 1px solid ${colors.$gray300};
    border-top: 3px solid ${colors.$dark_green};
    border-radius: 18px;
    padding: 20px;
    background: ${colors.$white};
    font: inherit;
    cursor: pointer;
    transition: box-shadow 0.15s;

    &:hover {
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
    }

    .expert-head {
      gap: 14px;
      margin-bottom: 16px;
    }

    .expert-avatar {
      width: 56px;
      height: 56px;
      background: ${colors.$dark_green};
      color: ${colors.$white};
      font-size: 20px;
      font-weight: 600;
      flex-shrink: 0;
      object-fit: cover;
    }

    .expert-name {
      font-size: 18px;
      color: ${colors.$gray900};
    }

    .expert-role {
      font-size: 13px;
      color: ${colors.$gray600};
      line-height: 1.4;
    }

    .expert-bio {
      font-size: 14px;
      line-height: 1.6;
      color: ${colors.$gray600};
      margin: 0 0 20px;
      flex: 1;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .expert-foot {
      gap: 8px;
    }

    .prompts-badge {
      gap: 6px;
      background: ${colors.$bg_green};
      color: ${colors.$dark_green};
      padding: 6px 12px;
      font-size: 13px;
      font-weight: 500;

      i {
        font-size: 16px;
      }
    }

    .instagram {
      color: ${colors.$gray600};
      font-size: 13px;

      i {
        font-size: 16px;
      }
    }

    a.instagram {
      cursor: pointer;
      text-decoration: none;
      transition: color 0.2s ease;

      &:hover {
        color: #2b6a4e;
      }
    }
  }

  .prompts-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 20px;
  }

  .prompt-card {
    display: flex;
    flex-direction: column;
    border: 1px solid #e8e2de;
    border-radius: 16px;
    padding: 22px;
    background: ${colors.$white};
    transition: box-shadow 0.15s, border-color 0.15s;

    &:hover {
      border-color: #bfe0cf;
      box-shadow: 0 6px 18px rgba(0, 0, 0, 0.05);
    }

    .prompt-card-head {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 10px;
      margin-bottom: 12px;
    }

    .prompt-title {
      font-size: 18px;
      font-weight: 700;
      color: ${colors.$gray900};
      line-height: 1.3;
    }

    .topic-chip {
      flex-shrink: 0;
      font-size: 12px;
      color: #4a5568;
      background: #f4f4f5;
      border: 1px solid #e8e8ec;
      border-radius: 999px;
      padding: 4px 10px;
      white-space: nowrap;
    }

    .prompt-summary {
      font-size: 14px;
      color: ${colors.$gray600};
      line-height: 1.6;
      margin: 0 0 20px;
      flex: 1;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .prompt-card-foot {
      display: flex;
      align-items: center;
      gap: 10px;
    }

    .use-button {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      border: none;
      border-radius: 999px;
      padding: 9px 18px;
      font-size: 14px;
      font-weight: 600;
      color: ${colors.$white};
      background: linear-gradient(135deg, #2eb872 0%, #2b6a4e 100%);
      cursor: pointer;

      i {
        font-size: 18px;
      }

      &:hover {
        filter: brightness(0.96);
      }

      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }

    .copy-button {
      width: 38px;
      height: 38px;
      flex-shrink: 0;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #e2e8f0;
      border-radius: 50%;
      background: ${colors.$white};
      color: #4a5568;
      cursor: pointer;

      i {
        font-size: 18px;
      }

      &:hover {
        background: #f7fafc;
      }
    }

    .full-button {
      display: inline-flex;
      align-items: center;
      gap: 2px;
      margin-left: auto;
      border: none;
      background: none;
      color: ${colors.$gray600};
      font-size: 14px;
      cursor: pointer;

      i {
        font-size: 18px;
      }

      &:hover {
        color: #2a2a2a;
      }
    }
  }

  .library-empty {
    color: ${colors.$gray500};
    font-size: 15px;
    padding: 24px 0;
  }
`;
